import { render } from "./Categories.vue?vue&type=template&id=5be8d185&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5be8d185"

export default script